/**
 * Expected data object to be passed, via postMessage, between frames
 * @param {String} provider security protocol - only accept messages from like providers
 * @param {String} message  unique string for routing/handling of specific messages
 * @param {*}      data     other info to be passed
 */
const MessagePayload = function( provider, message, data = null )
  {
    if( !provider ) throw "`provider` is invalid";
    if( !message  ) throw "`message` is invalid";

    this.provider = provider;
    this.message  = message;
    this.data     = data;
  };


export { MessagePayload as default };